import React, { useMemo } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Tooltip,
  TooltipProps,
  Typography,
  styled,
  tooltipClasses,
} from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import "./index.css";
import Image from "next/image";
import { AddToCartService } from "../../../services/cart";
import { Guide } from "./Guide";
import { useCurrencyCode } from "../helper-functions/CurrencySymbol";
import MaxServiceAlert from "./MaxServiceAlert";
import InfoIcon from "@mui/icons-material/Info";

interface BestPairedProps {
  id: any;
  cid: any;
  url: any;
  heading: any;
  subHeading: any;
  finalPrice: any;
  price: any;
  handleViewDetailsBestPaired: any;
  handleOpenViewDetailsRsOne: any;
  addOn: any;
  updateCard: any;
  setUpdateCard: any;
  reloadViewDetailsItem: any;
  productDetailsAvailable: any;
  aboutList: any;
  serviceCharge: any;
  productCost: any;
  min: any;
  specialPrice: any;
  specialMessage: any;
}

export const BestPaired: React.FC<BestPairedProps> = ({
  id,
  cid,
  url,
  heading,
  subHeading,
  finalPrice,
  price,
  handleViewDetailsBestPaired,
  handleOpenViewDetailsRsOne,
  addOn,
  updateCard,
  setUpdateCard,
  reloadViewDetailsItem,
  productDetailsAvailable,
  aboutList,
  serviceCharge,
  productCost,
  min,
  specialPrice,
  specialMessage,
}) => {
  const [isClicked, setIsClicked] = React.useState(false);
  const [openMaxService, setOpenMaxService] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [value, setVaue] = React.useState(1);
  const addToCartService = useMemo(() => new AddToCartService(), []);
  const currencyCode = useCurrencyCode();

  React.useEffect(() => {
    var jsonCount = addToCartService.checkIfAvailable(id, cid);
    if (jsonCount.count > 0) {
      setIsClicked(true);
      setVaue(jsonCount.count);
    } else {
      setIsClicked(false);
    }
    setUpdateCard(false);
  }, [updateCard, addToCartService, id, cid, setUpdateCard]);

  const handleClickButton = async () => {
    console.log("id of service add into cart " + id);
    setIsLoading(true);
    if (addOn == true) {
      handleOpenViewDetailsRsOne();
      setIsLoading(false);
    } else {
      var countJson = await addToCartService.addToCart(
        id,
        true,
        cid,
        url,
        aboutList,
        subHeading,
        serviceCharge,
        productCost,
        min,
        specialPrice,
        specialMessage
      );
      if (countJson?.count && countJson?.count > 0) {
        setVaue(countJson?.count);
        setIsClicked(true);
        reloadViewDetailsItem();
        setIsLoading(false);
      } else {
        setIsClicked(false);
        reloadViewDetailsItem();
        setIsLoading(false);
      }
    }
  };

  const handleValueDecrease = async () => {
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      id,
      false,
      cid,
      url,
      aboutList,
      subHeading,
      serviceCharge,
      productCost,
      min,
      specialPrice,
      specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson?.count);
      setIsClicked(true);
      reloadViewDetailsItem();
      setIsLoading(false);
    } else {
      setIsClicked(false);
      reloadViewDetailsItem();
      setIsLoading(false);
    }
  };

  const handleValueIncrease = async () => {
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      id,
      true,
      cid,
      url,
      aboutList,
      subHeading,
      serviceCharge,
      productCost,
      min,
      specialPrice,
      specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      reloadViewDetailsItem();
      if (countJson?.count === 5) {
        setOpenMaxService(true);
      }
      setIsLoading(false);
    } else {
      setIsClicked(false);
      reloadViewDetailsItem();
      setIsLoading(false);
    }
  };

  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#15741a",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#15741a",
      color: "white",
    },
  }));

  return (
    <>
      <Box
        sx={{
          height: "185px",
          borderRadius: "0.5rem",
          boxShadow: "1px 1px 4px 1px rgba(0, 0, 0, 0.1)",
          margin: "12px",
          minWidth: "220px",
          maxWidth: "220px",
          background: "#fff",
          padding: "5px",
        }}
      >
        <Box
          sx={{
            overflow: "hidden",
            borderRadius: "0.5rem 0.5rem 0px 0px",
            height: "70px",
          }}
        >
          <Image
            src={url}
            alt="icon"
            className="card-image-animation"
            style={{
              objectFit: "cover",
              height: "70px",
              width: "100%",
              borderRadius: "0.5rem 0.5rem 0px 0px",
            }}
            width={500}
            height={200}
            priority={true}
            rel="preload"
          />
        </Box>
        <Box
          sx={{ padding: "0.5rem 0px", position: "relative", height: "105px" }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: "bold",
                fontSize: "12px",
                textWrap: "nowrap",
                overflow: "scroll",
                marginBottom: "4px",
                textOverflow: "ellipsis",
                maxWidth: productDetailsAvailable == true ? "10rem" : "auto",
                "&:: -webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              {heading}
            </Typography>
            {productDetailsAvailable == true && <Guide serviceId={id} />}
            <BootstrapTooltip title="View Details" placement="top">
              <InfoIcon
                sx={{
                  color: "#15741a",
                  cursor: "pointer",
                  fontSize: "20px",
                }}
                onClick={handleViewDetailsBestPaired}
              />
            </BootstrapTooltip>
          </Box>
          <Typography
            variant="body2"
            sx={{
              fontSize: "11px",
              textWrap: "nowrap",
              overflow: "auto",
              textOverflow: "ellipsis",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            {subHeading}
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              position: "absolute",
              bottom: 0,
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "grid",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontWeight: "bold", color: "#000" }}
              >
                {currencyCode}
                {finalPrice?.toLocaleString()}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "100",
                  color: "gray",
                  textDecoration: "line-through",
                }}
              >
                {currencyCode}
                {price?.toLocaleString()}
              </Typography>
            </Box>
            {isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "80px",
                  background: "none",
                  borderRadius: "50px",
                  height: "30px",
                  border: "1px solid #15741a",
                }}
              >
                <CircularProgress size="20px" color="success" />
              </Box>
            ) : isClicked ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  fontWeight: "bold",
                  padding: "6px",
                  borderRadius: "50px",
                  width: "80px",
                  height: "30px",
                  background: "#15741a",
                  color: "white",
                }}
              >
                <RemoveIcon
                  onClick={handleValueDecrease}
                  sx={{ cursor: "pointer", fontSize: "18px" }}
                />
                <Typography
                  sx={{
                    fontSize: "14px",
                  }}
                >
                  {value}
                </Typography>
                <AddIcon
                  onClick={handleValueIncrease}
                  sx={{ cursor: "pointer", fontSize: "18px" }}
                />
              </Box>
            ) : (
              <Button
                variant="contained"
                sx={{
                  fontSize: "11px",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  padding: "6px",
                  borderRadius: "50px",
                  width: "80px",
                  height: "30px",
                  boxShadow: "none",
                  backgroundColor: "#15741a",
                }}
                color="success"
                onClick={handleClickButton}
              >
                Add
              </Button>
            )}
          </Box>
        </Box>
      </Box>
      <MaxServiceAlert
        openInfo={openMaxService}
        handleClose={() => setOpenMaxService(false)}
      />
    </>
  );
};

export default BestPaired;
